import { useDisclosure } from "@heroui/react";
import { InputField, ModalBuilder, ModalError } from "./../modalBuilder";
import { api } from "@/api";
import { toast } from "react-toastify";
import useErrorHandling from "@/hooks/useErrorHandling";
import { useState } from "react";
import { VisitRequest } from "@/api/visit-requests";

interface ICreateVisitRequestForm {
  status: string;
}

const createVisitRequestFields: InputField[] = [
  {
    label: "Статус",
    name: "status",
    placeholder: "Новая",
    type: "visit-request-status",
    isRequired: true,
  },
];

export function EditVisitRequestModal({
  disclosure,
  visitRequest,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
  visitRequest: VisitRequest | null;
}) {
  const { isOpen, onOpenChange } = disclosure;
  const [modalErrors, setModalErrors] = useState<ModalError[]>([]);

  const handleError = useErrorHandling();

  const onSubmit = (data: ICreateVisitRequestForm) => {
    return new Promise<boolean>((resolve) => {
      api.visitRequests
        .updateStatus(
          visitRequest?.id || 0,
          data.status as "new" | "progress" | "done" | "close",
        )
        .then(() => {
          disclosure.onClose();
          resolve(true);
        })
        .catch((err) => {
          console.log(err);
          const { errorMessage, parsedErrors } = handleError(err);
          setModalErrors(parsedErrors || []);
          toast.error(errorMessage);
          resolve(false);
        });
    });
  };

  const onDelete = () => {
    return new Promise<boolean>((resolve) => {
      api.visitRequests
        .updateStatus(visitRequest?.id || 0, "close")
        .then(() => {
          disclosure.onClose();
          resolve(true);
        })
        .catch((err) => {
          console.log(err);
          const { errorMessage, parsedErrors } = handleError(err);
          setModalErrors(parsedErrors || []);
          toast.error(errorMessage);
          resolve(false);
        });
    });
  };

  return (
    <ModalBuilder
      title="Изменение статуса заявки"
      modalErrors={modalErrors}
      fields={createVisitRequestFields}
      isOpen={isOpen}
      isSensitiveData={false}
      onOpenChange={onOpenChange}
      onSubmit={onSubmit}
      onDelete={onDelete}
      submitButtonText="Сохранить"
      defaultValues={{
        status: visitRequest?.status,
      }}
      deleteButtonText="Закрыть заявку"
    />
  );
}
